/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const currency = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m1.156 3.333 1.4 2.334 2.333-1.4m.74-3.174A4.201 4.201 0 0 0 2.88 5.378m11.964 7.289-1.4-2.334-2.333 1.4m-.74 3.174a4.202 4.202 0 0 0 2.749-4.284m-1.256-8.056h-1.849c-.283 0-.557.099-.776.277a1.2 1.2 0 0 0-.295 1.51c.136.247.354.44.617.544l1.876.744c.263.105.48.297.616.544a1.199 1.199 0 0 1-.294 1.51 1.227 1.227 0 0 1-.776.277H9.136M10.5 2.568V1.5m0 7.5V7.973M5.608 14a2.74 2.74 0 0 1-1.929-.792 2.69 2.69 0 0 1-.799-1.91c0-.718.288-1.405.8-1.912a2.74 2.74 0 0 1 1.928-.791m-4.091 2.702h4.09"
    />
  </svg>
)
export default currency
